module.exports = __webpack_public_path__ + "img/analytics-marketing-team-4.574c7bd5.svg";